/* eslint-disable array-callback-return */
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import { useAuthentication } from 'src/context/AuthContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	FILE_UPLOAD_FORMAT_XLSX,
	FORM_FIELDS_TYPES,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	KOSTENTRAEGER,
	PARTNER_DATEN_NICHT_ERFASST,
	PLATZHALTER_TEXT,
} from 'src/lib/constants/constant';
import { PUBLIC_DOCUMENTS_PATHS } from 'src/lib/constants/publicDocumentPaths';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import PositionLiegtNichtVor from 'src/pages/private/online-antrag/antrag-components/PositionLiegtNichtVor';
import { InhaltTrenner, InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import {
	addIndexesToPath,
	checkReadOnlyInUeberarbeitung,
	getOptionsFromRes,
	handleDownloadFile,
	isObjectEmpty,
	isTrue,
	removeDataKeys,
	removeNullDeep,
} from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
	getSelectedKostenKategorieObject,
} from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenKategorieSchema from 'src/lib/paths/kostenkategorie_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenPositionSchema.attributes;
const KK_P = KostenKategorieSchema.attributes;

const PersonalkostenAntragStipendium: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { authenticatedData } = useAuthentication();
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const kostentraeger = KOSTENTRAEGER.Antragsteller;
	const unternehmenId = get(authenticatedData, 'organisationId');
	const [kostenKategorie, setKostenKategorie] = useState([]);
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	// Hanlde Add and Delete Personalkosten
	const handleAddPersonalkosten = async () => {
		let appCopy = cloneDeep(application);
		let data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Sachkosten, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Personalkosten,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeletePersonalkosten = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};

	// Fetch Kosten kategorie for Personalkosten
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Ausgabe,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Personalkosten,
						Allgemein_Antragsformular: {
							$contains: get(application, P.Allgemein_Antragsformular.path),
						},
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: FEtching Kosten kategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />
			<PositionLiegtNichtVor kostenPosition={KOSTEN_POSITION.Ausgabe} kostenArt={KOSTEN_ARTEN.Personalkosten} updatedReadOnly={updatedReadOnly} />
			<InhaltTrenner marginTop='1rem' />
			<InhaltWrapper marginTop='1rem' marginBottom='1rem'>
				<Typography fontWeight={'bold'}>Zu den förderfähigen Personalausgaben gehören</Typography>
				<ul>
					<li>
						direkte Ausgaben für eigenes Personal, soweit es unmittelbar für die Durchführung des Vorhabens eingesetzt wird
						(„Arbeitgeberbrutto“, bestehend aus lohnsteuerpflichtigem Bruttogehalt zzgl. Arbeitgeberanteil an der Sozialversicherung und
						arbeits-/tarifvertraglich verpflichtenden Jahressonderzahlungen wie Urlaubs- und Weihnachtsgeld). Bonuszahlungen oder ähnliche
						Sondervergütungen sind nicht zuwendungsfähig. Es werden die tatsächlichen Zahlungen im Projektzeitraum gemäß Gehaltsnachweis
						berücksichtigt,
					</li>
					<li>unbare (unentgeltliche) Eigenarbeitsleistungen mit Stundennachweis, bemessen mit dem gesetzlichen Mindestlohn.</li>
				</ul>
				<Typography>Der Stundensatz wird mit der Kalkulationsdatei berechnet.</Typography>
			</InhaltWrapper>
			<InhaltTrenner marginTop='0' />
			<InhaltWrapper>
				<Typography fontWeight={'bold'}>Personalkostenkalkulation / Berechnung Stundensatz</Typography>
				<Typography>
					Der Stundensatz wird mit der Kalkulationsdatei berechnet. Für diese Berechnungen haben wir Ihnen eine Excel-Vorlage erstellt. Die
					Angaben, die sich in dem Dokument errechnen, werden für die weiteren Eingaben im Portal benötigt.
				</Typography>
				<Typography>
					Bitte laden Sie hier die Datei „push_Personalkostenkalkulation“ (Excel-Datei) herunter, füllen Sie es vollständig aus und speichern Sie
					es anschließend wieder als .xlsx-Datei:
				</Typography>
				<Button
					variant={'outlined'}
					startIcon={<DownloadIcon />}
					sx={{ maxWidth: 'fit-content' }}
					onClick={() =>
						handleDownloadFile(PUBLIC_DOCUMENTS_PATHS.antragsUnterlagen.Stipendium.KalkulationPersonalKosten.KalkulationVorlageExcel)
					}
				>
					push_Personalkostenkalkulation
				</Button>
			</InhaltWrapper>
			<InhaltTrenner marginTop='1rem' marginBottom='1rem' />

			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					const selectedKostenKategorieObjekt = getSelectedKostenKategorieObject(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path));
					const isVertragVorhanden =
						isObjectEmpty(get(ele, KP_P.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes.Arbeitsvertrag.path, {})) ? false : (
							true
						);
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Personalkosten | ${get(ele, KP_P.Allgemein_Bezeichnung.path, '')}`}
							onDelete={() => handleDeletePersonalkosten(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapPersonalkosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(
									kostenKategorie,
									get(ele, KP_P.Allgemein_Kostenkategorie.path),
									get(application, P.Allgemein_Antragsformular.path),
								)}
							/>

							<Grid2 spacing={6} container>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalkosten(formStruc1(), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalkosten(formStruc2(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
							</Grid2>
							<CreateForm
								formStruc={mapPersonalkosten(kostenProJahrStruc(application, i, kostenKategorie), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
							/>

							{isTrue(get(selectedKostenKategorieObjekt, KK_P.Zusaetzlicheinfor_Upload_Arbeitsvertrag_Notwendig.path)) ?
								<>
									<InhaltTrenner marginTop='1rem' />
									<InhaltWrapper marginTop='1rem' marginBottom='1rem'>
										<Typography fontWeight={'bold'}>Upload Arbeitsvertrag</Typography>
										<Typography>
											Bitte laden Sie hier den unterzeichneten Arbeitsvertrag als .pdf-Datei hoch. Der Dateiname sollte eindeutig sein
											(z.B. „Arbeitsvertrag_Vorname_Nachname.pdf“).
										</Typography>
									</InhaltWrapper>
									<CreateForm
										formStruc={mapPersonalkosten(formStrucUploadVertrag(), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
									{isVertragVorhanden ?
										<></>
									:	<>
											<Typography sx={{ mt: '1rem' }}>
												Falls noch kein Arbeitsvertrag vorliegt, kreuzen Sie dies bitte unten an.
											</Typography>
										</>
									}
									<CreateForm
										formStruc={mapPersonalkosten(formStrucUploadNichtNoetig(ele), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
								</>
							:	<></>}

							<InhaltTrenner marginTop='1rem' />
							<InhaltWrapper marginTop='1rem' marginBottom='1rem'>
								<Typography fontWeight={'bold'}>Upload der Personalkostenkalkulation</Typography>
								<Typography>
									Bitte laden Sie hier die Personalkostenkalkulation für die betreffende Person als .xlsx-Datei hoch. Der Dateiname sollte
									eindeutig sein (z.B. {'<PK_Name_Kategorie>'}; Beispiel: „PK_Mara_Muster_Gehalt“).
								</Typography>
							</InhaltWrapper>
							<CreateForm
								formStruc={mapPersonalkosten(formStrucKalkulationExcel(), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
							/>
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} disabled={updatedReadOnly} onClick={handleAddPersonalkosten}>
					Personalkosten hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};

export default PersonalkostenAntragStipendium;

// Prüfassistenz
const PruefAssistenzStruc = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
// Form Struc Personalkosten
const formStruc1 = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
					label: 'Name',
					tooltip: 'Wenn der Name der eingesetzten Person noch nicht feststeht, kann N.N. eingetragen werden.',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
const formStruc2 = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'singleSelect',
					options: getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung'),
					label: 'Beschäftigungsart gemäß Personalkostenkalkulation',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const kostenProJahrStruc = (application: any, i: number, _allkategories: any[]) => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr,
					type: FORM_FIELDS_TYPES.editableTable,
					maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
					fieldProps: {
						Zelle_2: { format: 'currency', label: 'Personalkosten' },
					},
					disabledColumns: ['Zelle_1'],
					tableLabel: 'Ausgaben pro Jahr',
					hideDeleteButton: true,
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Gesamt',
							Zelle_2: get(
								application,
								addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								),
							),
						},
					],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;

	/**
	 * BITTE ZUERST LESEN
	 * Laut das Ticket HA-2329 muss die Block füer Personalkostenkalkulation vorerst rausgenommen werden.
	 * Es wird ab jetzt nur noch die Ausgaben pro Jahr Block angezeigt.
	 *
	 * Aber HA ändert die AFO immer ständig. Daher erstmal nur es ausblendet bzw. auskommentieren, damit es nicht komplett gelöscht ist
	 */
	// const kategoriePath = addIndexesToPath(
	// 	P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie.path,
	// 	[`${i}`],
	// 	['Foerderantrag_Kostenpositions'],
	// );
	// const selectedKostenKategorieObjekt = getSelectedKostenKategorieObject(allkategories, get(application, kategoriePath));
	// const MindeslohnVorbelegen = isTrue(get(selectedKostenKategorieObjekt, KK_P.Zusaetzliche_Information_Mindestlohn_Vorbelegen.path));

	// const struc: FormStrucItem[] = [
	// 	{
	// 		fields: [
	// 			{
	// 				...P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes
	// 					.Projektjahr_Block,
	// 				fieldProps: {
	// 					Stundensatz: { format: 'currency' },
	// 					StundAusgabenensatz: { format: 'currency' },
	// 					Ausgaben: { format: 'currency' },
	// 					Anzahl: { label: 'Anzahl der geplanten Projektstunden' },
	// 				},
	// 				disabledColumns: ['Projektjahr', 'Ausgaben', ...(MindeslohnVorbelegen ? ['Stundensatz'] : [])],
	// 				type: 'componentTable',
	// 				tableLabel: 'Ausgaben pro Jahr',
	// 				maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
	// 				hideDeleteButton: true,
	// 				sumRow: [
	// 					{
	// 						id: 'pinnedRow',
	// 						Projektjahr: 'Gesamt',
	// 						Anzahl: get(
	// 							application,
	// 							addIndexesToPath(
	// 								P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes
	// 									.Gesamt_Anzahl.path,
	// 								[`${i}`],
	// 								['Foerderantrag_Kostenpositions'],
	// 							),
	// 						),
	// 						Ausgaben: get(
	// 							application,
	// 							addIndexesToPath(
	// 								P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
	// 								[`${i}`],
	// 								['Foerderantrag_Kostenpositions'],
	// 							),
	// 						),
	// 					},
	// 				],
	// 			},
	// 		],
	// 		userProps: { columnToDivide: 1 },
	// 	},
	// ];

	// return struc;
};
const formStrucUploadVertrag = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes.Arbeitsvertrag,
					hideLabel: true,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
	return struc;
};
const formStrucUploadNichtNoetig = (currentPosition: any) => {
	const isVertragVorhanden =
		isObjectEmpty(get(currentPosition, KP_P.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes.Arbeitsvertrag.path, {})) ? false : (
			true
		);

	let struc: FormStrucItem[] = [];

	if (!isVertragVorhanden) {
		struc = [
			{
				fields: [
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes
							.Arbeitsvertrag_Liegt_Nicht_Vor,
						validation: isVertragVorhanden ? [] : [{ validateFunction: ForceTrue }],
					},
				],
				userProps: { direction: 'column', columnToDivide: 1 },
			},
		];
	}

	return struc;
};
// Form Struc Personalkosten Kalkulation Excel
const formStrucKalkulationExcel = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Personalausgaben_Startup_Stipendium.schema.attributes
						.Personalkostenkalkulation,
					hideLabel: true,
					allowedFileNameKeywords: ['PK'],
					allowedFormats: [FILE_UPLOAD_FORMAT_XLSX],
					// validation: [{ validateFunction: Required }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
	return struc;
};

// Map kosten
const mapPersonalkosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				return {
					...value,
					path: addIndexesToPath(get(value, 'path', ''), [`${index}`], ['Foerderantrag_Kostenpositions']),
				};
			}),
		};
	});
	return result;
};

export function getFormStrucPersonalkostenAntragStipendium(application: any, kostenKategories: any[], unternehmenId?: number): FormStrucItem[] {
	let formStruc: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);

			const formStrucCTWithIndex = getFormStrucComponentTable(
				application,
				mapPersonalkosten(kostenProJahrStruc(application, i, kostenKategories), i),
			);

			const formStruc1WithIndex = mapPersonalkosten(formStruc1(), i);
			const formStruc2WithIndex = mapPersonalkosten(formStruc2(), i);
			let formStrucArbeitsvertragWithIndex = [];
			let formStrucArbeitsvertragNichtNoetigWithIndex = [];
			const formStrucKalkulationExcelWithIndex = mapPersonalkosten(formStrucKalkulationExcel(), i);

			const selectedKostenKategorieObjekt = getSelectedKostenKategorieObject(kostenKategories, get(ele, KP_P.Allgemein_Kostenkategorie.path));

			if (isTrue(get(selectedKostenKategorieObjekt, KK_P.Zusaetzlicheinfor_Upload_Arbeitsvertrag_Notwendig.path))) {
				formStrucArbeitsvertragWithIndex = mapPersonalkosten(formStrucUploadVertrag(), i);
				formStrucArbeitsvertragNichtNoetigWithIndex = mapPersonalkosten(formStrucUploadNichtNoetig(ele), i);
			}

			if (isHinweisFieldRequired) {
				formStruc = concat(
					mapPersonalkosten(PruefAssistenzStruc(), i),
					formStruc,
					formStruc1WithIndex,
					formStruc2WithIndex,
					formStrucArbeitsvertragWithIndex,
					formStrucArbeitsvertragNichtNoetigWithIndex,
					formStrucKalkulationExcelWithIndex,
				);
			} else {
				formStruc = concat(
					formStruc,
					formStruc1WithIndex,
					formStruc2WithIndex,
					formStrucCTWithIndex,
					formStrucArbeitsvertragWithIndex,
					formStrucArbeitsvertragNichtNoetigWithIndex,
					formStrucKalkulationExcelWithIndex,
				);
			}
		}
	});
	return formStruc;
}
